// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Cta-cls1___d9d6493abcf462cad35{/*!*/}.Cta-cls2___0aeb61ae65e64e81038{color:#223;cursor:pointer}.Cta-cls2___0aeb61ae65e64e81038:hover{text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Cta-cls1___d9d6493abcf462cad35",
	"cls2": "Cta-cls2___0aeb61ae65e64e81038 Cta-cls1___d9d6493abcf462cad35"
};
export default ___CSS_LOADER_EXPORT___;
